<template>
  <v-footer class="fontSize" padless color="primary" dark>
    <v-col class="text-start" cols="12">
      © 2017-{{ new Date().getFullYear() }} Global Psytech Sdn. Bhd.
    </v-col>
  </v-footer>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>
.fontSize {
  font-size: 13px;
}
</style>